// material-ui
import { useTheme } from '@mui/material/styles';

// project imports

/**
 * if you want to use image instead of <svg> uncomment following.
 *
 * import logoDark from 'assets/images/logo-dark.svg';
 * import logo from 'assets/images/logo.svg';
 *
 */

export default function Logo({ isMini = false }) {
  const theme = useTheme();

  return (
    <img
      src={`${process.env.PUBLIC_URL}/cLogo.png`}
      alt="AXOPeople"
      width={isMini ? "42" : "190"}
      height={isMini ? "42" : "60"}
      style={{
        margin: 'auto',
        objectFit: 'contain',
        transition: 'all 0.3s ease-in-out',
        maxWidth: '100%'
      }}
    />
  );
}
